import React, { ReactNode, useRef } from 'react';

interface RoutePrefetchProps {
  prefetch: () => void;
  children: ReactNode;
}

// Fires `prefetch` exactly once per route mount, during the parent's
// render pass — so the API calls start before the children mount and
// trigger their own fetches. The page components consume the same
// in-flight promises from dataCache, skipping the network round trip.
const RoutePrefetch: React.FC<RoutePrefetchProps> = ({ prefetch, children }) => {
  const fired = useRef(false);
  if (!fired.current) {
    fired.current = true;
    prefetch();
  }
  return <>{children}</>;
};

export default RoutePrefetch;
